import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendExtractedBlogInstructions,
  BackendMutationExtractBlogInstructionsArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ExtractBlogInstructions(
    $sectionId: ID!
    $url: String!
    $headline: String
    $projectId: ID
  ) {
    extractBlogInstructions(
      sectionId: $sectionId
      url: $url
      headline: $headline
      projectId: $projectId
    ) {
      id
    }
  }
`;

type Variables = BackendMutationExtractBlogInstructionsArgs;
type Result = Pick<BackendExtractedBlogInstructions, 'id'>;

export const extractBlogInstructionsBasedOnURL = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });

  return getSingleProp<Result>(result.data);
};
